import { render } from "./StackItem.vue?vue&type=template&id=517f9e14"
import script from "./StackItem.vue?vue&type=script&lang=js"
export * from "./StackItem.vue?vue&type=script&lang=js"
script.render = render

export default script